import { createAction } from 'redux-actions';

export const portalUsersOnClear = createAction('PORTAL_USERS_ON_CLEAR');

export const portalUsersOnChangePage = createAction(
  'PORTAL_USERS_ON_CHANGE_PAGE'
);

export const portalUsersOnChangeOrder = createAction(
  'PORTAL_USERS_ON_CHANGE_ORDER'
);
